<template>
  <div class="wrapper">
    <navbar></navbar>
    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container ">
          <router-link to="top">{{$t('ordertop.myhome')}}</router-link> / <router-link to="order">{{$t('top.myorder')}}</router-link> / <router-link to="order-list">{{$t('OrderListTop.OrderList')}}</router-link>
          <div class="accordion mt-4" id="accordionExample">
            <div class="card">
              <div class="card-header p-0" id="headingOne">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 " type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {{$t('orderlist.AppInfo')}}
                  </button>
                </h2>
              </div>
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="number">{{$t('SearchColumn.NO')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input class="form-control" id="number" type="text" :value="orderInfo.order_no" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="applicationTime">{{$t('DisplayBar.Application')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="applicationTime" :value="moment(orderInfo.order_apply_time).format('YYYY-MM-DD HH:mm:ss')" aria-label="Recipient's username" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="updateTime">{{$t('DisplayBar.UpdateTime')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="updateTime" :value="moment(orderInfo.order_update_time).format('YYYY-MM-DD HH:mm:ss')" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="status">{{$t('SearchColumn.Status')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="status" :value="getStatus(status)" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingThree">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    {{$t('orderlist.Transaction')}}
                  </button>
                </h2>
              </div>
              <div id="collapseThree" class="collapse show" aria-labelledby="headingThree">
                <div class="card-body">
                  <form label-width="0px" class="demo-ruleForm pt-4 needs-validation" novalidate>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand" for="coinPaymentAddress">{{$t('orderlist.CoinPS')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" type="text" id="coinPaymentAddress" :value="orderInfo.payment_address" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand" for="coinAmount">{{$t('orderlist.CoinA')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon2">{{orderInfo.payment_coin_type}}</span>
                          </div>
                          <input type="number" id="coinAmount" class="form-control" :value="orderInfo.payment_coin_amount" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand" for="coinTXID">{{$t('orderlist.CoinTXID')}}</label>
                      </div>
                      <div class="col-12 col-md-8">
                        <div class="col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="coinTXID" v-model="orderInfo.payment_txid" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" required />
                          <div class="invalid-feedback">
                            {{$t('orderlist.TXIDTips')}}
                          </div>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4 pr-0">
                        <label class="navbar-brand pr-0" for="evidence">{{$t('orderlist.Evidence')}}<a tabindex="0" class="btn btn-sm border-0 p-0 mb-1" role="button" rel="evidence" data-toggle="popover" data-trigger="focus" :title="$t('orderListPopup.Evidence')" data-content=""><img src="../../../static/img/info.svg"></a></label>
                        <div class="evidence-intr" v-html="$t('orderListPopup.EvidenceIntr')">
                        </div>
                      </div>
                      <div class="form-inline col-12 col-md-8" style="height:120px">
                        <a href="#" id='saveAs' data-toggle="modal" v-if="imgBase64!=''" class="pr-3" data-target="#enlargeModal" @click="enlargeModal(imgBase64)"><img :src="imgBase64" height="100px" title="click to enlarge"></a>
                        <button class="btn btn-outline-primary" type="button" @click="imgUploadInput" v-if="status ==='AC'">{{$t('orderlist.ImgUpload')}}</button>
                        <input type="file" id="imgUpload" @change="uploaded($event)" multiple="multiplt" accept="image/*" v-show="false">
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand">{{$t('orderlist.Category')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <label for="isFairFx">{{$t('orderlist.isFairFX')}}</label>
                        <input type="radio" class="mr-4" :value="1" v-model="orderInfo.receive_account_type" id="isFairFx" :disabled="statusChangeToNo()!==1">
                        <label for="notFairFx">{{$t('orderlist.notFairFx')}}</label>
                        <input type="radio" :value="2" v-model="orderInfo.receive_account_type" @click="pop" id="notFairFx" :disabled="statusChangeToNo()!==1">
                      </div>
                    </nav>
                    <nav class="navbar col-12" v-if="orderInfo.receive_account_type === 1">
                      <div class="col-12 col-lg-4">
                        <label for="fairFX" class="navbar-brand">{{$t('orderlist.FairFXnum')}}</label>
                      </div>
                      <div class="col-12 col-md-8">
                        <div class="col-12 p-0">
                          <input type="text" maxlength="128" class="form-control" id="fairFX" v-model="orderInfo.fairfx_number" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 1">
                          <div class="invalid-feedback">
                            {{$t('orderlist.FairFXnumTipe')}}
                          </div>
                        </div>
                      </div>
                    </nav>
                    <div v-if="orderInfo.receive_account_type === 2">
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="accountHolderName" class="navbar-brand">{{$t('UpdateInfoForm.accountHolderName')}}</label>
                          <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" :title="$t('UpdateInfoForm.accountHolderName')" :data-content="$t('UpdateInfoForm.accountHolderNameTips')"><img src="../../../static/img/info.svg"></a>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="accountHolderName" v-model="orderInfo.account_name" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.accountHolderNameTips')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="firstName" class="navbar-brand">{{$t('UpdateInfoForm.firstName')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="firstName" v-model="orderInfo.first_name" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.firstName')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="lastName" class="navbar-brand">{{$t('UpdateInfoForm.lastName')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="lastName" v-model="orderInfo.last_name" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.lastName')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="street" class="navbar-brand">{{$t('UpdateInfoForm.myResidence')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input class="form-control" maxlength="128" id="street" v-model="orderInfo.account_street" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.myResidenceTips')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="city" class="navbar-brand">{{$t('UpdateInfoForm.mycity')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="city" v-model="orderInfo.account_city" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.mycityTips')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="postcode" class="navbar-brand">{{$t('UpdateInfoForm.myPostalCode')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="postcode" v-model="orderInfo.account_postcode" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.myPostalCodeTips')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="country" class="navbar-brand">{{$t('UpdateInfoForm.mycountry')}}</label>
                        </div>
                        <div class="form-inline col-12 col-md-8">
                          <div class="input-group col-12 p-0">
                            <input type="text" class="form-control" id="country" v-model="orderInfo.account_country" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1">
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="accountNumber" class="navbar-brand">{{$t('UpdateInfoForm.accountNumber')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="accountNumber" v-model="orderInfo.account_number" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.accountNumberTips')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="bankName" class="navbar-brand">{{$t('UpdateInfoForm.bankName')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="bankName" v-model="orderInfo.bank_name" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.bankName')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="bankStreet" class="navbar-brand">{{$t('UpdateInfoForm.bankStreet')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <div class="col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="bankStreet" v-model="orderInfo.bank_street" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.bankStreet')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="bankCountry" class="navbar-brand">{{$t('UpdateInfoForm.bankCountry')}}</label>
                        </div>
                        <div class="form-inline col-12 col-md-8">
                          <div class="input-group col-12 p-0">
                            <input type="text" class="form-control" id="bankCountry" v-model="orderInfo.bank_country" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1">
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="bankSWIFT" class="navbar-brand">{{$t('UpdateInfoForm.bankSWIFT')}}</label>
                        </div>
                        <div class="form-inline col-12 col-md-8">
                          <div class="input-group p-0 col-12">
                            <input type="text" maxlength="128" class="form-control" id="bankSWIFT" v-model="orderInfo.bank_swift" style="border-bottom-right-radius:0.35rem;border-top-right-radius:0.35rem;" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1" :required="orderInfo.receive_account_type === 2">
                            <label for="routing" class="navbar-brand ml-3">{{$t('UpdateInfoForm.routing')}}</label>
                            <input type="text" maxlength="128" class="form-control" id="routing" v-model="orderInfo.bank_routing" style="border-radius:0.35rem;" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1">
                            <div class="invalid-feedback">
                              {{$t('OListinfoxin.bankSWIFT')}}
                            </div>
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="IBAN" class="navbar-brand">{{$t('UpdateInfoForm.IBAN')}}</label>
                        </div>
                        <div class="form-inline col-12 col-md-8">
                          <div class="input-group col-12 p-0">
                            <input type="text" maxlength="128" class="form-control" id="IBAN" v-model="orderInfo.account_iban" aria-describedby="basic-addon2" :readonly="statusChangeToNo()!==1">
                          </div>
                        </div>
                      </nav>
                      <nav class="navbar col-12">
                        <div class="col-12 col-lg-4">
                          <label for="BACS" class="navbar-brand">{{$t('UpdateInfoForm.BACS')}}</label>
                        </div>
                        <div class="form-inline col-12 col-md-8">
                          <div class="custom-control custom-checkbox p-0 pl-4">
                            <input id="BACS" class="custom-control-input" type="checkbox" v-model="orderInfo.bank_bacs_sepa" aria-label="Checkbox for following text input" :disabled="statusChangeToNo()!==1">
                            <label class="custom-control-label" for="BACS"></label>
                          </div>
                        </div>
                      </nav>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingThree">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    {{$t('orderlist.ExchangeRI')}}
                  </button>
                </h2>
              </div>
              <div id="collapseFour" class="collapse show" aria-labelledby="headingFour">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="exchangeRate">{{$t('orderlist.ConfirmEdexchangeRate')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input class="form-control" type="text" id="exchangeRate" :value="orderInfo.exchange_rate" readonly>
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon2">{{$t('orderlist.USD')}}/{{orderInfo.payment_coin_type}}</span>
                        </div>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="amount">{{$t('orderlist.ConfirmedAmount')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon2">{{$t('orderlist.USD')}}</span>
                        </div>
                        <input type="number" class="form-control" id="amount" :value="orderInfo.exchange_amount" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="serviceCharge">{{$t('orderlist.ServiceCharge')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon2">{{$t('orderlist.USD')}}</span>
                        </div>
                        <input type="number" id="serviceCharge" class="form-control" :value="orderInfo.exchange_service_charge" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingFive">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseThree">
                    {{$t('orderlist.ContactMatters')}}
                  </button>
                </h2>
              </div>
              <div id="collapseFive" class="collapse show" aria-labelledby="headingFive">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="operatorMessage">{{$t('orderlist.Operatormessage')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-12">
                      <div class="input-group col-12 p-0">
                        <textarea class="form-control" id="operatorMessage" v-model="orderInfo.message_operator" rows="3" readonly></textarea>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="userMessage">{{$t('orderlist.Usermessage')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-12">
                      <div class="input-group col-12 p-0">
                        <textarea class="form-control" maxlength="255" id="userMessage" rows="3" v-model="orderInfo.message_user" :readonly="statusChangeToNo()===2||statusChangeToNo()===4||statusChangeToNo()===7"></textarea>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-between mt-4 mr-3">
            <div class="justify-content-start p-0 ml-3">
              <router-link to="order-list" class="btn btn-outline-secondary">{{$t('OrderTerms.BackButton')}}</router-link>
            </div>
            <div class="row justify-content-end p-0">
              <button type="button" class="btn btn-outline-secondary mr-2" @click="submit('save')" v-if="statusChangeToNo()===1||statusChangeToNo()===3||statusChangeToNo()===5||statusChangeToNo()===6">{{$t('orderlist.Savebtn')}}</button>
              <button type="button" class="btn btn-danger mr-2" @click="submit('GU')" v-if="statusChangeToNo()===1">{{$t('orderlist.Giveup')}}</button>
              <button type="button" class="btn btn-primary" @click="submit('WC')" v-if="statusChangeToNo()===1">{{$t('orderlist.Request')}}</button>
            </div>
          </div>
        </div>

      </div>
    </main>

    <copyright></copyright>
    <div class="modal fade" id="enlargeModal" style="z-index:111111" tabindex="-1" role="dialog" aria-labelledby="enlargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <img :src="imgNow" style="margin: 0 auto;max-width:100%" />
      </div>
    </div>

    <div class="modal fade" id="giveUpModal" tabindex="-1" role="dialog" aria-labelledby="giveUpModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('orderListPopup.Confirm')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center pt-0">
            <div class="m-4" v-if="newStatus!==status">
              {{$t('orderListPopup.Tipsgiup')}}
            </div>
            <div class="card mb-3">
              <div class="card-body">
                <div v-if="orderInfo.message_user!==oldOrderInfo.message_user">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderListPopup.UserMessage')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0"><label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <textarea class="form-control" style="border-radius:0.35rem;" id="exampleFormControlTextarea1" rows="3" v-model="oldOrderInfo.message_user" readonly></textarea>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0"><label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <textarea class="form-control border-success change" style="border-radius:0.35rem;" id="exampleFormControlTextarea1" rows="3" v-model="orderInfo.message_user" readonly></textarea>
                      </div>
                    </div>
                  </nav>
                </div>
                <nav class="navbar">
                  <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('SearchColumn.Status')}}</div>
                  <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                    <div class="input-group col-12 col-lg-5 pl-0 pr-0"><label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                      <input type="text" class="form-control" style="border-radius:0.35rem;" :value="getStatus(status)" aria-describedby="basic-addon2" readonly>
                    </div>
                    <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0"><label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                      <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" :value="getStatus(newStatus)" aria-describedby="basic-addon2" readonly>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div class="modal-footer pt-5 pb-3">
            <div class="col-6">
              <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
              </button>
            </div>
            <div class="col-6 text-right">
              <button class="btn btn-lg btn-primary" @click="giveUp" data-dismiss="modal">{{$t('modal.modalOk')}}</button>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>

    <div class="modal fade" id="requestModal" tabindex="-1" role="dialog" aria-labelledby="requestModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('orderListPopup.Confirm')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center pt-0">
            <div class="m-4" v-if="newStatus!==status">
              {{$t('orderListPopup.Tipsrequ')}}
            </div>
            <div class="m-4" v-if="newStatus===status">
              {{$t('orderListPopup.Tips')}}
            </div>
            <div class="card mb-3">
              <div class="card-body">
                <div v-if="orderInfo.payment_txid!==oldOrderInfo.payment_txid">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderlist.CoinTXID')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.payment_txid" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.payment_txid" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="picChanged">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderlist.Evidence')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0" v-if="oldOrderInfo.payment_evidence_id!==null">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <a href="#" id='saveAs' data-toggle="modal" data-target="#enlargeModal" @click="enlargeModal(oldImgBase64)"><img :src="oldImgBase64" max-width="200px" height="100px" title="click to enlarge"></a>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <a href="#" id='saveAs' data-toggle="modal" data-target="#enlargeModal" @click="enlargeModal(imgBase64)"><img :src="imgBase64" max-width="200px" height="100px" title="click to enlarge"></a>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.fairfx_number!==oldOrderInfo.fairfx_number&&orderInfo.receive_account_type === 1">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('OListinfoxin.fairFX')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.fairfx_number" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.fairfx_number" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.account_name!==oldOrderInfo.account_name&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.accountHolderName')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.account_name" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.account_name" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.account_street!==oldOrderInfo.account_street&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.myResidence')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.account_street" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.account_street" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.account_city!==oldOrderInfo.account_city&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.mycity')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.account_city" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.account_city" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.account_postcode!==oldOrderInfo.account_postcode&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.myPostalCode')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.account_postcode" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.account_postcode" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.account_country!==oldOrderInfo.account_country&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.mycountry')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" id="country" v-model="oldOrderInfo.account_country" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" id="country" v-model="orderInfo.account_country" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.account_iban!==oldOrderInfo.account_iban&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.IBAN')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.account_iban" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.account_iban" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.account_number!==oldOrderInfo.account_number&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.accountNumber')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.account_number" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.account_number" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.bank_name!==oldOrderInfo.bank_name&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.bankName')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.bank_name" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.bank_name" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.bank_street!==oldOrderInfo.bank_street&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.bankStreet')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.bank_street" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.bank_street" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.first_name!==oldOrderInfo.first_name&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.firstName')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.first_name" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.first_name" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.last_name!==oldOrderInfo.last_name&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.lastName')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.last_name" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.last_name" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.bank_country!==oldOrderInfo.bank_country&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.mycountry')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" id="country" v-model="oldOrderInfo.bank_country" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" id="country" v-model="orderInfo.bank_country" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.bank_swift!==oldOrderInfo.bank_swift&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.bankSWIFT')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.bank_swift" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.bank_swift" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.bank_routing!==oldOrderInfo.bank_routing&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.routing')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" v-model="oldOrderInfo.bank_routing" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" v-model="orderInfo.bank_routing" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.bank_bacs_sepa!==oldOrderInfo.bank_bacs_sepa&&orderInfo.receive_account_type === 2">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('UpdateInfoForm.BACS')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="custom-control custom-checkbox col-6 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="justify-content-center justify-content-lg-start pl-0 text-center text-lg-left"></label>
                        <input id="BACS" class="custom-control-input" type="checkbox" v-model="oldOrderInfo.bank_bacs_sepa">
                        <label class="custom-control-label ml-4"></label>
                      </div>
                      <div class="custom-control custom-checkbox col-6 col-lg-5 pl-0 mr-lg-5 pr-0 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="justify-content-center justify-content-lg-start pl-0 text-center text-lg-left"></label>
                        <input id="BACS" class="custom-control-input" type="checkbox" v-model="orderInfo.bank_bacs_sepa">
                        <label class="custom-control-label ml-4"></label>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.message_user!==oldOrderInfo.message_user">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderListPopup.UserMessage')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <textarea class="form-control" style="border-radius:0.35rem;" id="exampleFormControlTextarea1" rows="3" v-model="oldOrderInfo.message_user" readonly></textarea>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <textarea class="form-control border-success change" style="border-radius:0.35rem;" id="exampleFormControlTextarea1" rows="3" v-model="orderInfo.message_user" readonly></textarea>
                      </div>
                    </div>
                  </nav>
                </div>
                <div>
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('SearchColumn.Status')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control" style="border-radius:0.35rem;" :value="getStatus(status)" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left "></label>
                        <input type="text" class="form-control border-success change" style="border-radius:0.35rem;" :value="getStatus(newStatus)" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer pt-5 pb-3">
            <div class="col-6">
              <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
              </button>
            </div>
            <div class="col-6 text-right">
              <button class="btn btn-lg btn-primary" @click="update" data-dismiss="modal">{{$t('modal.modalOk')}}</button>
            </div>
          </div>
        </div>

      </div><!-- /.modal-content -->
    </div><!-- /.modal -->

    <div class="modal fade" id="successModal" tabindex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('orderListPopup.Messgae')}}</h5>
            <button type="button" class="close" data-dismiss="modal" @click="init" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="p-4" v-if="status!==newStatus">{{$t('orderListPopup.change')}}</h5>
            <h5 class="p-4" v-if="status===newStatus">{{$t('orderListPopup.savesuccessful')}}</h5>
            <router-link to="order-list" class="btn btn-primary btn-lg popover-test mb-4" data-dismiss="modal">{{$t('orderListPopup.retrunorderList')}}</router-link>
          </div>

        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>

  </div>

</template>

<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import navbar from './navbar'
import copyright from './copyright'
import { NmsClient, RestCfg, Env } from '../../scripts/AllExport'
import Cookies from 'js-cookie'
let orderInfoGetType = 'order-info-get'
let orderInfoUpdateType = 'order-info-update'
let thisVue = null
const moment = require('moment')
export default {
  components: { navbar, copyright },
  data: function () {
    return {
      orderInfo: '',
      oldOrderInfo: '',
      status: '',
      newStatus: '',
      orderNo: '',
      imgBase64: '',
      oldImgBase64: '',
      picChanged: false,
      payment_evidence_picture: '',
      imgNow: '',
      notRequest: '',
      moment: moment
    }
  },
  mounted() {
    this.orderNo = this.$route.query.order_no
    this.init()
    thisVue = this
    $('[rel=evidence]').popover({
      html: true,
      content: function() {
        return thisVue.$t('orderListPopup.EvidenceTips')
      }
    })
  },
  methods: {
    getStatus (status) {
      switch (status) {
        case 'AC':
          return this.$t('status.AC')
        case 'GU':
          return this.$t('status.GU')
        case 'WC':
          return this.$t('status.WC')
        case 'C':
          return this.$t('status.C')
        case 'RA':
          return this.$t('status.RA')
        case 'CR':
          return this.$t('status.CR')
        case 'PC':
          return this.$t('status.PC')
      }
    },
    statusChangeToNo() {
      switch (this.status) {
        case 'AC':
          return 1
        case 'GU':
          return 2
        case 'WC':
          return 3
        case 'C':
          return 4
        case 'RA':
          return 5
        case 'CR':
          return 6
        case 'PC':
          return 7
      }
    },
    init() {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': orderInfoGetType,
          'orderNo': this.orderNo
        },
        (response) => {
          this.orderInfo = response.resultInfo
          if (this.orderInfo.receive_account_type === null) {
            this.orderInfo.receive_account_type = 1
          }
          this.orderInfo.bank_bacs_sepa = this.orderInfo.bank_bacs_sepa === 1
          this.status = this.orderInfo.order_status_code
          if (this.orderInfo.payment_evidence_id !== null) {
            this.download()
          }
          this.picChanged = false
          this.oldOrderInfo = {...this.orderInfo}
          $('[data-toggle="tooltip"]').tooltip()
          $(function () { $("[data-toggle='popover']").popover() })
          $('.needs-validation')[0].classList.remove('was-validated')
        },
        null
      )
    },
    pop() {
      $('[data-toggle="tooltip"]').tooltip()
      $(function () { $("[data-toggle='popover']").popover() })
    },
    update() {
      this.orderInfo.order_status_code = this.newStatus
      let form = new FormData()
      form.append('reqType', orderInfoUpdateType)
      form.append('picChanged', this.picChanged)
      form.append('notRequest', this.notRequest)
      form.append('file', this.payment_evidence_picture)
      form.append('orderInfo', JSON.stringify(this.orderInfo))
      form.append('isSave', this.newStatus === this.status)
      form.append('domain', document.domain)
      form.append('lang', Cookies.get('language'))
      NmsClient.send(
        RestCfg.POST,
        form,
        (response) => {
          $('#successModal').modal({backdrop: 'static', keyboard: false})
        },
        null
      )
    },
    giveUp() {
      this.oldOrderInfo.message_user = this.orderInfo.message_user
      this.oldOrderInfo.order_status_code = 'GU'
      let form = new FormData()
      form.append('reqType', orderInfoUpdateType)
      form.append('picChanged', false)
      form.append('notRequest', this.notRequest)
      form.append('orderInfo', JSON.stringify(this.oldOrderInfo))
      form.append('isSave', false)
      form.append('domain', document.domain)
      form.append('lang', Cookies.get('language'))
      NmsClient.send(
        RestCfg.POST,
        form,
        (response) => {
          $('#successModal').modal({backdrop: 'static', keyboard: false})
        },
        null
      )
    },
    uploaded(event) {
      if (event.target.files[0]) {
        if ((event.target.files[0].size / 1024 / 1024) > 5) {
          event.target.value = ''
          this.$alert(this.$t('orderListPopup.uploadFileOut'), this.$t('orderListPopup.Messgae'), {
            confirmButtonText: 'OK',
            lockScroll: false,
            closeOnClickModal: true,
            callback: action => {
            }
          })
          return
        }
        let file = event.target.files[0]
        if ((file.type.search(/^image/) === -1)) {
          event.target.value = ''
          this.$alert(this.$t('orderListPopup.uploadFileTypeWrong'), this.$t('orderListPopup.Messgae'), {
            confirmButtonText: 'OK',
            lockScroll: false,
            closeOnClickModal: true,
            callback: action => {
            }
          })
          return
        }
        let fileRead = new FileReader()
        fileRead.readAsDataURL(event.target.files[0])
        fileRead.onload = (e) => {
          this.payment_evidence_picture = event.target.files[0]
          this.imgBase64 = fileRead.result
          this.picChanged = true
        }
      }
    },
    download() {
      let data = {
        reqType: 'download',
        payment_evidence_id: this.orderInfo.payment_evidence_id,
        localhost: document.domain
      }

      let xhr = new XMLHttpRequest()
      xhr.open('POST', Env.URL_HEAD + 'post')
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', 'Bearer ' + Cookies.get('tokenId'))
      xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
      xhr.send(JSON.stringify(data))
      xhr.onloadend = (event) => {
        if (xhr.status === 200) {
          let blob = new Blob([xhr.response], {type: 'image/jpeg'})
          let objectURL = URL.createObjectURL(blob)

          /* let saveAs = document.getElementById('saveAs')
          saveAs.download = 'hello.jpg'
          saveAs.href = objectURL

          saveAs.onclick = (event) => {
            // イベントをキャンセル
            event.preventDefault()
            // process
          } */

          this.oldImgBase64 = objectURL
          this.imgBase64 = objectURL

          // URLオブジェクトを削除
          //   $('img')[0].onload = () => {
          //     URL.revokeObjectURL(objectURL)
          //   }
        }
      }
    },
    enlargeModal(imgBase64) {
      this.imgNow = imgBase64
    },
    imgUploadInput() {
      $('#imgUpload').click()
    },
    submit(mode) {
      if (mode === 'save') this.newStatus = this.status
      else if (mode === 'GU') this.newStatus = 'GU'
      else if (mode === 'WC') this.newStatus = 'WC'
      this.notRequest = this.newStatus === this.status
      if (mode === 'GU') this.notRequest = true
      let formValidation = $('.needs-validation')[0]
      if (!this.notRequest) {
        formValidation.classList.add('was-validated')
        if ($('.form-control:invalid').length !== 0) $('.form-control:invalid')[0].focus()
      }
      if (this.notRequest || formValidation.checkValidity()) {
        formValidation.classList.remove('was-validated')
        if (!this.notRequest && this.imgBase64 === '') {
          return this.$alert('Please submit the picture', 'Message', {
            confirmButtonText: 'OK',
            lockScroll: false,
            closeOnClickModal: true,
            callback: action => {
              $('#imgUpload').focus()
            }
          })
        }
        if (mode === 'GU') $('#giveUpModal').modal('show')
        else $('#requestModal').modal('show')
      }
    }
  }

}
</script>
<style scoped>
.navbar {
  font-weight: normal;
}
.navbar-brand {
  font-size: 1.25rem;
}
.container{
  min-height:calc(100vh - 256px)
}
.change:focus{
  color:#495057;
  outline:0;
  -webkit-box-shadow:0 0 0 .2rem rgba(17,175,34,.25);
  box-shadow:0 0 0 .2rem rgba(17,175,34,.25)
}

.evidence-intr >>> a{
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-color: #dee2e6;
  padding-bottom: 2px;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.evidence-intr >>> a:hover{
  border-color: #adb5bd;
}

</style>



// WEBPACK FOOTER //
// src/components/user/order-info.vue